<template>
  <div style="clear:both;">
    <v-card>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" sm="10">
            <v-textarea variant="underlined" :label="$t('Revision_Reason')" name="reason" :model-value="revisionReasonText" auto-grow readonly></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <people-picker :label="$t('Revision_By')" readonly :user="revisionUser" :inUser="revisionUser"></people-picker>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field variant="underlined" dense :model-value="$filters.DateTimeFilter(revisionDateValue)" readonly density="comfortable"></v-text-field>
          </v-col>
        </v-row>

        <template v-if="(revisionHistoryLog || []).length > 0">
          <v-row>
            <v-col cols="12">{{ 'History' }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="revisionHistoryLog"
                class="elevation-1"
                :footer-props="pagination"
                :options.sync="options"
                :sort-by="options.sortBy"
                :sort-desc="options.descending"
              >
                <template v-slot:item="props">
                  <tr>
                    <td>
                      <v-textarea variant="underlined" auto-grow readonly :rows="1" :model-value="props.item.reason"></v-textarea>
                    </td>
                    <td>{{ revisionUserDisplayName(props.item.user) }}</td>
                    <td>{{ $filters.DateTimeFilter(props.item.date) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
export default {
  data() {
    return {
      pagination: {
        'items-per-page-options': [10, 20, 30, 40]
      },
      options: {
        itemsPerPage: 20,
        sortBy: ['date'],
        descending: true
      },
      headers: [
        {
          title: this.$t('Revision_Reason'),
          align: 'left',
          key: 'reason'
        },
        { title: this.$t('Revision_By'), key: 'user' },
        { title: this.$t('Revision_Date'), key: 'date' }
      ]
    }
  },
  props: {
    revisionReason: {
      type: Object,
      default: null
    },
    roles: {
      type: Array,
      default: null
    },
    revisionHistory: {
      type: Array,
      default: null
    }
  },
  components: {
    PeoplePicker
  },
  methods: {
    revisionUserDisplayName: function(user) {
      return user ? user.displayName : ''
    }
  },
  computed: {
    revisionUser: function() {
      return (this.revisionReason || {}).user
    },
    revisionReasonText: function() {
      return (this.revisionReason || {}).reason
    },
    revisionDateValue: function() {
      return (this.revisionReason || {}).date
    },
    revisionHistoryLog: function() {
      return (this.revisionHistory || []).slice(0, this.revisionHistory.length - 1)
    }
  }
}
</script>

<style scoped></style>
